<template>
  <div class="dashboard-home">
    <BaseContainer
      :permission-list="['registry_manager']"
    >
      <template v-slot:header-title>
        Gestão de Registro
      </template>
      <template v-slot:header-title-description>
        Perfil de usuário: Gestor
      </template>
      <div class="app-align-items-center mb-4">
        <v-autocomplete
          id="qa-id-name-program-list"
          v-model="selectedProgram"
          :items="programList"
          return-object
          item-value="id"
          item-text="initiator"
          label="Selecione o programa"
          :rules="[isValid]"
          style="max-width: 250px;"
          class="mr-2"
          :disabled="editingDashboard"
          @change="changeSelectProgram"
        />
      </div>
      <template v-if="(!hasDash && selectedProgram.initiator && userIsAdmin) || !hideDashboard">
        <template v-if="selectedProgram.initiator !== 'TODOS'">
          <v-tabs
            v-model="tab"
            background-color="transparent"
            class="mt-2"
          >
            <v-tab
              v-for="tab in ['Financeiro', 'Operacional']"
              :key="tab"
              :disabled="editingDashboard"
            >
              {{ tab }}
            </v-tab>
          </v-tabs>
          <v-tabs-items
            v-model="tab"
            style="background:transparent;"
          >
            <v-tab-item
              v-for="tabItem, tabIndex in configurationId"
              :key="tabIndex"
              class="pt-6"
              :transition="false"
            >
              <BaseDashboard
                :selected-role="selectedRole"
                :selected-program="selectedProgram"
                :selected-configuration-id="configurationId[tab]"
                @isEditingDashboard="isEditingDashboard"
              />
            </v-tab-item>
          </v-tabs-items>
        </template>
        <template v-else-if="selectedProgram.initiator === 'TODOS'">
          <BaseDashboard
            :selected-role="selectedRole"
            :selected-program="selectedProgram"
            selected-configuration-id=""
            @isEditingDashboard="isEditingDashboard"
          />
        </template>
      </template>
      <div
        v-else
        class="my-12"
      >
        Não há dados para exibir. Utilize os filtros acima para buscar novos dados.
      </div>
    </BaseContainer>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import BaseContainer from '../BaseContainer'
import BaseDashboard from '../BaseDashboard'
import permissions from '../../mixins/permissions'

export default {
  components: { BaseContainer, BaseDashboard },
  mixins: [ permissions ],
  data: () => ({
    selectedProgram: null,
    selectedRole: 'owner',
    roleList: [ { text: 'Gestor', value: 'owner' } ],
    tab: 0,
    configurationId: ["dashboard_url_registry_finance_", "dashboard_url_registry_operation_"],
    editingDashboard: false
  }),
  computed: {
    ...mapState({
      allPrograms: state => state.platformProgram.allPrograms,
      platformsMePrograms: state => state.platformProgram.platformsMePrograms
    }),
    programList() {
      let listPrograms = this.allPrograms.filter(elem => elem.is_owner).sort((a, b) => a.name.localeCompare(b.name))
      let listAllPrograms = []
      listAllPrograms.push(...listPrograms)
      listAllPrograms.unshift({initiator: 'TODOS', ...this.platformsMePrograms})
      return listAllPrograms
    },
    hideDashboard(){
      return !this.selectedProgram || !this.selectedRole || !this.hasDash
    },
    hasDash(){
      let list = []
      if(this.selectedRole && this.selectedProgram.configuration){
        Object.keys(this.selectedProgram.configuration).forEach(key => {
          if(key.includes(`dashboard_url_registry_finance_${this.selectedRole}`) || key.includes(`dashboard_url_registry_operation_${this.selectedRole}`)){
            list.push(this.selectedProgram.configuration[key])
          }
        })
        return list.length ? true : false
      } if(this.selectedProgram.initiator === 'TODOS'){
        list.push(this.mePrograms)
        return list.length ? true : false
      }
      return false
    },
  },
  watch:{
    selectedProgram: {
      async handler(value) {
        this.tab = 0
        this.selectedProgram = value
      },
      deep: true
    },
    platformsMePrograms: {
      handler() {
        this.$nextTick(()=>{
          this.selectedProgram = {initiator: 'TODOS', ...this.platformsMePrograms}
        })
      },
      deep: true
    },
    allPrograms: {
      handler() {
        if(this.selectedProgram){
          this.selectedProgram = this.programList.filter(program => program.initiator === this.selectedProgram.initiator)[0]
        }
      }
    },
    selectedRole () {
      this.tab = 0
    },
  },
  async created(){
    this.selectedProgram = {initiator: 'TODOS', ...this.platformsMePrograms}
    await this.apiGetAllPrograms()
  },
  methods: {
    ...mapActions(["apiGetAllPrograms", "apiGetMePrograms"]),
    changeSelectProgram(val) {
      this.$nextTick(() => {
        this.selectedProgram = Object.assign({}, {...val})
      })
    },
    isEditingDashboard(value) {
      this.editingDashboard = value
    }
  },
}
</script>
